module.exports = __webpack_public_path__ + "static/media/Hugfimi-hollow-side.90d866ee.png";